import { render, staticRenderFns } from "./VaPageLayout.vue?vue&type=template&id=01acd6b6"
import script from "./VaPageLayout.vue?vue&type=script&lang=js"
export * from "./VaPageLayout.vue?vue&type=script&lang=js"
import style0 from "./VaPageLayout.vue?vue&type=style&index=0&id=01acd6b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports